import { getCurrentEvent, isEventDate } from '@/common/events/common/util.js';


export default {
    computed: {
        isEventDate() {
            return isEventDate();
        },
        getCurrentEvent() {
            return getCurrentEvent();
        },
    },
}
